// extracted by mini-css-extract-plugin
export default {"base":"Back_base_a9601"};